export default "__VITE_ASSET__ea56b348__"